import { Link } from 'react-router-dom';
import { dossiers } from '@/mocks/dossiers';
import DimensionTag from '@/components/feature/DimensionTag';

export default function TimelineCorridor() {
  const target = dossiers.find((item) => item.id === 'deleted-post') ?? dossiers[0];
  const keyCount = target.timeline.filter((node) => node.tone === 'key').length;

  return (
    <section id="timeline" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-secondary-600">时间线长廊 / TIMELINE</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">关键节点，按时钟排开</h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
            我们只标注真正改变走向的节点。被讨论最多的那几步，未必是决定性的那几步。
          </p>
        </div>

        <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div className="flex flex-wrap items-center gap-3">
              <DimensionTag id={target.dimension} />
              <span className="font-label text-xs text-foreground-500">共 {target.timeline.length} 个节点 · {keyCount} 个关键节点</span>
            </div>
            <Link
              to={`/dossier/${target.id}`}
              className="inline-flex items-center gap-1.5 whitespace-nowrap font-label text-sm text-foreground-700 hover:text-primary-600"
            >
              查看完整档案
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950 md:text-xl">{target.title}</h3>

          <div className="relative mt-8 overflow-x-auto pb-2">
            <div className="hidden lg:block absolute left-0 right-0 top-[7px] h-px bg-background-300" />
            <ol className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-5 lg:gap-5">
              {target.timeline.map((node) => (
                <li key={node.time} className="relative min-w-[190px]">
                  <span className="font-label text-xs tracking-wide text-foreground-500">{node.time}</span>
                  <div className="relative mt-3 flex items-center">
                    <span
                      className={`relative z-10 flex h-4 w-4 items-center justify-center rounded-full border-2 ${
                        node.tone === 'key'
                          ? 'border-primary-500 bg-primary-500'
                          : 'border-background-400 bg-background-50'
                      }`}
                    >
                      {node.tone === 'key' && <span className="h-1.5 w-1.5 rounded-full bg-background-50" />}
                    </span>
                    {node.tone === 'key' && (
                      <span className="ml-2 whitespace-nowrap rounded-full bg-primary-50 px-2 py-0.5 font-label text-[10px] text-primary-700">
                        关键
                      </span>
                    )}
                  </div>
                  <h4 className="mt-4 font-heading text-sm font-semibold leading-snug text-foreground-900">{node.title}</h4>
                  <p className="mt-2 font-body text-xs leading-relaxed text-foreground-600">{node.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}